/**
 * Mainbeauty — nút "Xem thêm" cho danh sách server in sẵn ([data-pi-more], item thừa mang [hidden]).
 */
$(function () {
	document.querySelectorAll("[data-pi-more]").forEach(function (list) {
		const btn = list.querySelector("[data-pi-more-btn]");
		if (!btn) {
			return;
		}
		const step = Math.max(1, parseInt(list.dataset.piMore, 10) || 1);

		const foot = btn.closest(".pi-more__foot");

		const hiddenItems = function () {
			return list.querySelectorAll("[data-pi-more-item][hidden]");
		};

		// Hết item: mờ dần + xẹp chiều cao rồi mới bỏ nút, tránh nội dung dưới nhảy lên.
		const fadeOutBtn = function () {
			const still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
			if (!foot || still) {
				btn.hidden = true;
				return;
			}
			foot.style.height = foot.offsetHeight + "px";
			void foot.offsetHeight; // ép reflow để trình duyệt lấy mốc height
			foot.classList.add("pi-more__foot--out");
			foot.style.height = "0px";
			foot.addEventListener("transitionend", function done(e) {
				if (e.target !== foot || e.propertyName !== "height") {
					return;
				}
				foot.removeEventListener("transitionend", done);
				btn.hidden = true;
				foot.style.height = "";
			});
		};

		btn.addEventListener("click", function () {
			if (btn.hidden || (foot && foot.classList.contains("pi-more__foot--out"))) {
				return;
			}
			Array.prototype.slice.call(hiddenItems(), 0, step).forEach(function (item) {
				item.removeAttribute("hidden");
				// Gỡ lớp animation ngay khi chạy xong để DOM không đọng state.
				item.classList.add("pi-more__item--in");
				item.addEventListener("animationend", function done(e) {
					if (e.target !== item) {
						return; // animation của phần tử con (mũi tên, shine…)
					}
					item.classList.remove("pi-more__item--in");
					item.removeEventListener("animationend", done);
				});
			});
			if (!hiddenItems().length) {
				fadeOutBtn();
			}
		});
	});
});
